import React from "react";
import { Layout } from 'antd';
import "../../Styles/HomeStyles.css";

const Comp1 = () => {
  const { Content } = Layout;

  return (
    <Content className="home-hero">
      <div className="home-hero__content">
        <h1 className="home-hero__title">
          NATIONAL CENTER OF GIS AND SPACE APPLICATIONS
        </h1>
        <p className="home-hero__description">
          A state-of-the-art research center of Pakistan targeted towards identification
          and mitigation of the most profound challenges in the domain of GIS and Space
          Applications through research and capacity building initiatives at a national level.
        </p>
      </div>
    </Content>
  );
};

export default Comp1;
